import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Modal, Button } from 'shpmtcd'

class ActionFeedback extends Component {
  render() {
    const { showFeedback, onSubmit, onCancel } = this.props
    return (
      <>
        <Modal
          title='Confirm change?'
          width={300}
          wrapClassName='vertical-center-modal actionFeedback'
          visible={showFeedback}
          onOk={onSubmit}
          onCancel={onCancel}
          footer={[
            <Button key='cancel' onClick={onCancel}>No</Button>,
            <Button key='save' type='Primary' onClick={onSubmit}>Yes</Button>,
          ]}
        >
          <p>You will need to use the new email to login.</p>
        </Modal>
      </>
    )
  }
}

ActionFeedback.propTypes = {
  showFeedback: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default ActionFeedback
